export default __webpack_public_path__ + "28b14081435471fbab6888da1707fdbe.png";